<template>
  <div class="text-static-default-hi body-2-bold mb-28 md:mb-32">
    <div class="flex flex-col gap-8">
      <template v-for="item in reassuranceBlocks" :key="item.type">
        <ItemObsolete v-if="item.type !== 'active'" :item />
      </template>
      <slot :merchant name="shipping" :shipping>
        <DeliveryPromise :merchant :shipping />
      </slot>
      <slot :carrier name="carrier">
        <ItemCarrier
          :carrier
          :tracking="{
            zone: 'carrier_compatibility',
            name: 'carrier_info',
          }"
        />
      </slot>
      <ItemReassurance :tracking :warranty-delay />
      <ItemVerifiedRefurbished v-if="showVerifiedRefurbished" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import DeliveryPromise from '~/scopes/shipping/components/DeliveryPromise/DeliveryPromise.vue'

import ItemCarrier from './components/ItemCarrier/ItemCarrier.vue'
import ItemObsolete from './components/ItemObsolete/ItemObsolete.vue'
import ItemReassurance from './components/ItemReassurance/ItemReassurance.vue'
import ItemVerifiedRefurbished from './components/ItemVerifiedRefurbished/ItemVerifiedRefurbished.vue'

withDefaults(
  defineProps<{
    carrier: GetProductResponse['carrier']
    shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
    merchant: NonNullable<GetPickersResponse['selectedOffer']>['merchant']
    warrantyDelay?: string | null
    showVerifiedRefurbished?: GetProductResponse['showVerifiedRefurbished']
    reassuranceBlocks: GetProductResponse['reassuranceBlocks']
  }>(),
  {
    warrantyDelay: undefined,
    showVerifiedRefurbished: false,
  },
)

const tracking = computed(() => {
  return { zone: 'return_info', name: '30_days_return' }
})
</script>
